import { clsxMerge } from "shared/lib/helpers";
import { CurrentCallerBadge } from "./current-caller-badge";
import { useInCallContext } from "@/hooks/dialer/use-dialer-context";
import { useDialerCallStatus } from "@/hooks/dialer/use-dialer-call-status";
import { DIALER_CALL_STATUS } from "@/constants/dialer";
import { useMemo } from "react";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { ContactLocalTime } from "@/modules/pipeline/account-details/shared/contact-local-time";

import { EndedLabelOnly } from "@/components/modules/calling/cards/lead-card/v2/lead-avatar/connection-label/ended";
import { ConnectedLabelOnly } from "@/components/modules/calling/cards/lead-card/v2/lead-avatar/connection-label/connected";

export const LeadAdditionalInfo = () => {
  const { contact: callContact } = useInCallContext();
  const { contacts } = useAccountDetailsContext();

  const callStatus = useDialerCallStatus();
  const { startAt } = useInCallContext();

  const isConnected = callStatus === DIALER_CALL_STATUS.DURING && !!startAt;
  const isEnded = callStatus === DIALER_CALL_STATUS.AFTER;

  const contact = useMemo(
    () => contacts?.find((c) => c.id === callContact?.id),
    [callContact, contacts]
  );

  return (
    <div
      className={clsxMerge(
        "flex flex-col items-end justify-center",
        "text-white",
        "mt-10 p-3"
      )}
    >
      <span className={clsxMerge("typography-body-5-medium", "mb-2")}>
        Local time for contact <ContactLocalTime timezone={contact?.timezone} />
      </span>

      {isConnected && <ConnectedLabelOnly className="mb-1" />}
      {isEnded && <EndedLabelOnly className="mb-1" />}

      <CurrentCallerBadge />
    </div>
  );
};
